import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import EventData from 'shared/data/Event';
import ItemSetListData from 'shared/data/ItemSetList';

const async = { asyncResult: true };
const GlobalElementModalActions = Reflux.createActions({
  populate: async,
  populateEventList: async,
  addGlobalElementItemRowBelow: async,
  refreshGlobalElementShowItems: async,
  reorderShowRows: async,
  deleteRow: {},
  setLatestRenderedRowIndex: {},
});

GlobalElementModalActions.populateEventList.listenAndPromise(
  EventData.getByTeamIdWithShows,
);

GlobalElementModalActions.refreshGlobalElementShowItems.listenAndPromise(
  ShowData.getGlobalElementShowItems,
);

/**
 * @param teamId
 * @param eventId
 * @param showId
 * @returns {*}
 */
const loadShow = (teamId, eventId, showId) => {
  return Promise.all([
    ShowData.get(teamId, eventId, showId),
    ItemSetListData.get(teamId, eventId, showId),
    ShowData.getGlobalElementShowItems(teamId, eventId, showId),
  ]).then((results) => {
    return {
      show: results[0],
      itemSetList: results[1],
      globalElementShowItems: results[2],
    };
  });
};

GlobalElementModalActions.populate.listenAndPromise(loadShow);

export default GlobalElementModalActions;
